import styled from '@emotion/styled';
import { ob } from '../../onboardingV2.tokens';

export const Wrapper = styled.div`
    margin-top: 4px;
`;

export const Row = styled.div`
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    margin-bottom: 8px;
    font-size: 13px;
    line-height: 1;
    font-weight: 500;
    color: ${ob.color.muted};
    font-variant-numeric: tabular-nums;
`;

export const Percent = styled.span`
    font-weight: 700;
    color: ${ob.color.brand};
`;

export const Track = styled.div`
    height: 8px;
    border-radius: ${ob.radius.pill};
    background: ${ob.color.borderSubtle};
    overflow: hidden;
`;

export const Fill = styled.div`
    height: 100%;
    border-radius: ${ob.radius.pill};
    background: ${ob.color.lime};
    transition: width 300ms ease-out;

    ${ob.reducedMotion} {
        transition: none;
    }
`;
